import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./NeedHandChild.module.css";
// import arrowright from "../../assets/arrow-right.png";
import { FaArrowRightLong } from "react-icons/fa6";
import { Box, IconButton, Typography } from "@mui/material";
import { position } from "stylis";

const NeedHandChild = ({ title, desc1, desc2, desc3, path, question }) => {
  console.log("pathpathpath", path);

  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);

  const handleNavigate = () => {
    // Passing the 'question' as part of the state
    navigate(path, { state: { question, title } });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.5 } // Adjust the threshold as needed
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);
  const styleFont = {
    fontSize: "0.98rem",
    color: title === "Tutorials" ? "#fff" : 'rgba(80, 90, 99, 1)'
  };
  return (
    <div
      onClick={handleNavigate}
      ref={containerRef}
      style={{
        position: "relative",
        transform: isVisible ? "translateY(0)" : "translateY(50px)",
        opacity: isVisible ? 1 : 0,
        transition: "transform 0.5s ease-in-out, opacity 0.5s ease-in-out",
        cursor: "pointer",
        backgroundColor: title === "Tutorials" && 'rgba(0, 164, 242, 1)',
      }}
      className={classes.need_hand_child}
    >
      <h3 style={{ color: title === "Tutorials" && '#fff' }}>{title}</h3>
      <p style={styleFont}>{desc1}</p>
      <p style={styleFont}>{desc2}</p>
      <p style={styleFont}>{desc3}</p>

      {/* <img
        onClick={handleNavigate}
      // onClick={() => navigate(path)} 
      src={"./arrows.png"} alt={title} style={{ cursor: "pointer",}}  /> */}
      {title != "Tutorials" &&
        <Box style={{ position: 'absolute', right: 19,  display: 'flex', bottom: -5 }}>
         
          <Typography variant="body2" style={{ fontSize: '15px', color: 'rgba(36, 148, 201, 1)' }}>
            View all →
          </Typography>

        </Box>}
    </div>
  );
};

export default NeedHandChild;
